'use strict';

import mergeOpts from './merge-opts';
import fd from './promise-fastdom';
import {trigger} from './events';

/**
 * This utility toggles classes on given element when there’s an overflow
 * in any direction: top, bottom, left or right.
 * That allow, for example, to display shadows on a scrollable container.
 */

export default function Overflow(viewport, opts) {
    this.c = viewport;

    this.o = mergeOpts({
        prefix: 'overflow',
        threshold: 10,
        element: this.c.parentNode,
    }, opts);

    this.u = () => {
        this.update();
    };

    this.u();
    window.addEventListener('resize', this.u);
    viewport.addEventListener('scroll', this.u);
    
    this.mu = new MutationObserver(this.u);
    this.mu.observe(viewport, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true,
    });
}

Overflow.prototype.update = function () {
    return fd.mutate(() => {

        let top = false,
            right = false,
            bottom = false,
            left = false;

        if (this.c.scrollHeight > this.c.clientHeight) {
            top = this.c.scrollTop > this.o.threshold;
            bottom = this.c.scrollHeight - this.c.clientHeight - this.c.scrollTop > this.o.threshold;
        }
        if (this.c.scrollWidth > this.c.clientWidth) {
            left = this.c.scrollLeft > this.o.threshold;
            right = this.c.scrollWidth - this.c.clientWidth - this.c.scrollLeft > this.o.threshold;
        }

        this.o.element.classList.toggle(`${this.o.prefix}-top`, top);
        this.o.element.classList.toggle(`${this.o.prefix}-bottom`, bottom);
        this.o.element.classList.toggle(`${this.o.prefix}-left`, left);
        this.o.element.classList.toggle(`${this.o.prefix}-right`, right);

        trigger.call(this.o.element, 'overflow/update', [top, right, bottom, left]);
    }).catch(console.error);
};

Overflow.prototype.destroy = function () {
    return fd.mutate(() => {
        window.removeEventListener('resize', this.u);
        this.c.removeEventListener('scroll', this.u);
        this.mu.disconnect();
        this.o.element.classList.remove(`${this.o.prefix}-top`);
        this.o.element.classList.remove(`${this.o.prefix}-bottom`);
        this.o.element.classList.remove(`${this.o.prefix}-left`);
        this.o.element.classList.remove(`${this.o.prefix}-right`);
    }).catch(console.error);
};
